import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Box, Typography, TextField } from "@mui/material";
import MDButton from "components/MDButton";

export default function ListaEstudiantesModal({ open, handleClose, onGenerar, carreras, capacitaciones}) {
  const [filtros, setFiltros] = useState({
    nombre: "",
    programa_id: "",
    semestre_id: "",
    grupo_id: "",
    formato: "",
  });
  const [grupos, setGrupos] = useState([]); 
  const [semestres, setSemestres] = useState([]);
  const [loadingGrupos, setLoadingGrupos] = useState(false);
  const token = sessionStorage.getItem("access_token");
  const tipoPrograma = filtros.programa_id?.split("-")[0];

  // Cargar programas
  useEffect(() => {
    if (!open)
    {
        setFiltros({
            nombre: "",
            programa_id: "",
            grupo_id: "",
            formato: "",
        });

        // Limpiar listas
        setGrupos([]);
    }

  }, [open]);

  useEffect(() => {
    const cargarSemestres = async () => {
      if (!filtros.programa_id) return;

      const [tipo, id] = filtros.programa_id.split("-");

      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/semestre/${tipo}/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const data = await res.json();
        const lista = Array.isArray(data) ? data : data.data || [];

        setSemestres(lista);
        setGrupos([]); // limpiamos grupos
        setFiltros((prev) => ({ ...prev, grupo_id: "", semestre_id: "" }));
      } catch (err) {
        console.error(err);
        setSemestres([]);
      }
    };

    cargarSemestres();
  }, [filtros.programa_id]);

  // Cargar grupos según programa seleccionado
  useEffect(() => {
    const cargarGrupos = async () => {
      if (!filtros.semestre_id) return;

      setLoadingGrupos(true);

      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/grupos/${filtros.semestre_id}/semestres`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const data = await res.json();
        const lista = Array.isArray(data) ? data : data.data || [];

        setGrupos(lista);
      } catch (err) {
        console.error(err);
        setGrupos([]);
      } finally {
        setLoadingGrupos(false);
      }
    };

    cargarGrupos();
  }, [filtros.semestre_id]);

  const handleChange = (e) => {
  const { name, value } = e.target;

  setFiltros((prev) => ({
    ...prev,
    [name]: value,
    ...(name === "programa_id" ? { semestre_id: "", grupo_id: "" } : {}),
    ...(name === "semestre_id" ? { grupo_id: "" } : {}),
  }));
};

  const handleGenerar = async () => {
    if (!filtros.programa_id || !filtros.semestre_id || !filtros.grupo_id) {
      alert("Selecciona programa, semestre y grupo");
      return;
    }

    const [tipo, id] = filtros.programa_id.split("-");

    try {
      const url = `${process.env.REACT_APP_API_URL}/listaEstudiantes/${tipo}/${filtros.grupo_id}`
        + `?programa_id=${id}`
        + `&semestre_id=${filtros.semestre_id}` // 🔥 NUEVO
        + `&formato=${filtros.formato.toLowerCase()}`;

      console.log("URL FINAL:", url); // para debug

      window.open(url, "_blank");

      handleClose();
    } catch (err) {
      console.error("Error al enviar datos", err);
      alert("Error al enviar datos al backend");
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          outline: "none",
        }}
      >
        <Typography variant="h6" mb={2}>
          Crear Lista de Estudiantes
        </Typography>

        {/* Select de programas */}
        <TextField
          fullWidth
          select
          label="Carrera / Capacitación"
          name="programa_id"
          margin="dense"
          value={filtros.programa_id || ""}
          onChange={handleChange}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
        >
          <option value=""></option>
          {carreras.map((c) => (
            <option key={`carrera-${c.id}`} value={`carrera-${c.id}`}>
              Carrera: {c.nombre}
            </option>
          ))}
          {capacitaciones.map((c) => (
            <option key={`capacitacion-${c.id}`} value={`capacitacion-${c.id}`}>
              Capacitación: {c.nombre}
            </option>
          ))}
        </TextField>
        <TextField
          fullWidth
          select
          label={tipoPrograma === "capacitacion" ? "Módulo" : "Semestre"}
          name="semestre_id"
          margin="dense"
          value={filtros.semestre_id || ""}
          onChange={handleChange}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
          disabled={!semestres.length}
        >
          <option value=""></option>
          {semestres.map((s) => (
            <option key={s.id} value={s.id}>
              {tipoPrograma === "capacitacion"
                ? s.nombre // 🔥 solo nombre
                : `${s.nombre} ${s.numero}`} {/* 🔥 carrera */}
            </option>
          ))}
        </TextField>

        {/* Select dependiente de grupos */}
        <TextField
          fullWidth
          select
          label="Grupo"
          name="grupo_id"
          margin="dense"
          value={filtros.grupo_id || ""}
          onChange={handleChange}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
          disabled={!grupos.length} // deshabilitado si no hay grupos
        >
          <option value=""></option>
          {grupos.map((g) => (
            <option key={g.id} value={g.id}>
              {g.nombre}
            </option>
          ))}
        </TextField>
        <TextField
          fullWidth
          select
          label="Formato"
          name="formato"
          margin="dense"
          value={filtros.formato || ""}
          onChange={handleChange}
          SelectProps={{ native: true }}
          sx={{ mb:2 }}
        >
          <option value=""></option>
          <option value="PDF">Archivo PDF</option>
          <option value="EXCEL">Archivo Excel</option>
        </TextField>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <MDButton onClick={handleGenerar} color="info" variant="contained">
            Generar
          </MDButton>
        </Box>
      </Box>
    </Modal>
  );
}
